import React from "react";
import css from "../carrousel.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";
import { ReactComponent as Arrow } from "../../../../assets/icons/arrow/Slider.svg";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import CardBannerDestaque from "./CardBannerDestaque";
import useMediaQuery from "../../../hooks/useMediaQuery ";

export default function BannerDestaque({
  ViaturasDestaques,
  infoJson,
  selectedItems,
  addToCompare,
  removeFromCompare,
  alltexto,

  autoPlay,
}) {
  const ismobile = useMediaQuery("(max-width: 574px)");
  const responsive = {
    0: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
  };

  const navigationDestaquePrevRef = React.useRef(null);
  const navigationDestaqueNextRef = React.useRef(null);

  return (
    <Swiper
      className={`Destaques-Banners ${infoJson.Banner.Existe ? "top" : ""}`}
      breakpoints={responsive}
      autoplay={autoPlay ? true : false}
      pagination={
        ismobile
          ? {
              dynamicBullets: true,
            }
          : true
      }
      navigation={
        ismobile
          ? false
          : {
              prevEl: navigationDestaquePrevRef.current,
              nextEl: navigationDestaqueNextRef.current,
              disabledClass: css.buttonDisable,
              lockClass: css.buttonLock,
            }
      }
      onBeforeInit={(swiper) => {
        swiper.params.navigation.prevEl = navigationDestaquePrevRef.current;
        swiper.params.navigation.nextEl = navigationDestaqueNextRef.current;
      }}
      effect={"slide"}
      grabCursor="true"
      centeredSlides={true}
      loop={true}
      speed={500}
      modules={[Autoplay, Pagination, Navigation]}
    >
      {ViaturasDestaques.map((carro) => {
        return (
          <SwiperSlide key={carro.CodViatura}>
            <CardBannerDestaque
              data={carro}
              infoJson={infoJson}
              selectedItems={selectedItems}
              addToCompare={addToCompare}
              removeFromCompare={removeFromCompare}
              alltexto={alltexto}
            />
          </SwiperSlide>
        );
      })}
      {ismobile ? (
        <></>
      ) : (
        <>
          <div
            className={`${css.buttonPrev} ${css.buttonPrevB}`}
            ref={navigationDestaquePrevRef}
          >
            <Arrow
              style={{ transform: `rotate(180deg)` }}
              stroke={infoJson.Cores.ArrowSlider}
            />
          </div>
          <div
            className={`${css.buttonNext} ${css.buttonNextB}`}
            ref={navigationDestaqueNextRef}
          >
            <Arrow stroke={infoJson.Cores.ArrowSlider} />
          </div>
        </>
      )}
    </Swiper>
  );
}
